
(function () {
  'use strict';

  const WIDGET_SELECTOR = '.bogos-volume-discount-widget';
  const ITEM_SELECTOR = '.bogos-volume-discount-item';

  let lastTierSignature = '';
  let lastQuantityState = '';

  // 读取 BOGOS 所有活动阶梯
  function readBogosTiers() {
    const widgets = document.querySelectorAll(WIDGET_SELECTOR);
    const tiers = [];

    widgets.forEach(function (widget) {
      widget.querySelectorAll(ITEM_SELECTOR).forEach(function (item) {
        const quantityEl = item.querySelector(
          '.bogos-volume-discount-title'
        );

        const discountEl = item.querySelector(
          '.bogos-volume-discount-tier-discount-text'
        );

        if (!quantityEl || !discountEl) return;

        const quantity = parseInt(
          quantityEl.textContent.replace(/[^\d]/g, ''),
          10
        );

        const match = discountEl.textContent.match(/([\d.]+)\s*%/);

        if (!Number.isFinite(quantity) || !match) return;

        const discount = parseFloat(match[1]);

        tiers.push({
          quantity: quantity,
          discount: discount,
          discountText: discountEl.textContent.trim()
        });
      });
    });

    // 去重并排序
    const unique = Array.from(
      new Map(
        tiers.map(function (tier) {
          return [
            tier.quantity + '-' + tier.discount,
            tier
          ];
        })
      ).values()
    );

    return unique.sort(function (a, b) {
      return a.quantity - b.quantity;
    });
  }

  // 获取 Dawn 产品详情页数量输入框
  function getQuantityInput() {
    const selectors = [
      'product-info input[name="quantity"]',
      '.product__info-wrapper input[name="quantity"]',
      'form[action*="/cart/add"] input[name="quantity"]'
    ];

    for (const selector of selectors) {
      const inputs = Array.from(
        document.querySelectorAll(selector)
      );

      const input = inputs.find(function (el) {
        return (
          el.getClientRects().length > 0 &&
          !el.closest('cart-drawer, cart-notification')
        );
      });

      if (input) return input;
    }

    return null;
  }

  // 根据当前购买数量计算已解锁的阶梯
  function updateQuantityProgress() {
    const tiers = readBogosTiers();
    const quantityInput = getQuantityInput();

    if (!tiers.length || !quantityInput) return;

    const quantity = Math.max(
      0,
      parseInt(quantityInput.value, 10) || 0
    );

    let unlockedTier = null;
    let nextTier = null;

    tiers.forEach(function (tier) {
      if (quantity >= tier.quantity) {
        unlockedTier = tier;
      } else if (!nextTier) {
        nextTier = tier;
      }
    });

    const state = {
      quantity: quantity,
      unlockedTier: unlockedTier,
      nextTier: nextTier,
      tiers: tiers
    };

    const signature = JSON.stringify(state);

    if (signature === lastQuantityState) return;

    lastQuantityState = signature;

    console.log('[JG BOGOS] Quantity updated:', quantity);

    if (unlockedTier) {
      console.log(
        '[JG BOGOS] Current unlocked discount:',
        unlockedTier.discountText,
        '| Minimum quantity:',
        unlockedTier.quantity
      );
    } else {
      console.log(
        '[JG BOGOS] No discount unlocked yet.'
      );
    }

    if (nextTier) {
      console.log(
        '[JG BOGOS] Next target:',
        nextTier.quantity,
        'pcs | Need',
        Math.max(0, nextTier.quantity - quantity),
        'more pcs |',
        nextTier.discountText
      );
    } else {
      console.log(
        '[JG BOGOS] Maximum tier reached!'
      );
    }

    // 预留给后续自定义进度条 UI
    document.dispatchEvent(
      new CustomEvent('jg:bogos:quantity-updated', {
        detail: state
      })
    );
  }

  // 检测活动阶梯是否发生变化
  function checkTiers() {
    const tiers = readBogosTiers();

    if (!tiers.length) return;

    const signature = JSON.stringify(tiers);

    if (signature !== lastTierSignature) {
      lastTierSignature = signature;

      console.log('[JG BOGOS] Tiers detected:', tiers);

      lastQuantityState = '';
      updateQuantityProgress();
    }
  }

  // 监听数量输入和加减按钮
  document.addEventListener('input', function (event) {
    if (event.target.matches('input[name="quantity"]')) {
      updateQuantityProgress();
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('input[name="quantity"]')) {
      updateQuantityProgress();
    }
  });

  // 监听 BOGOS 动态加载和活动变化
  const observer = new MutationObserver(function () {
    checkTiers();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  console.log('[JG BOGOS] Quantity tracking initialized.');

  checkTiers();

})();
